import { IconPlayCircle, Modal, Spacing } from '@kezios/design-system';
import { Box, Flex } from '@mantine/core';

export type YoutubeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  youtubeUrl: string;
  title: string;
};

export const YoutubeModal = ({
  isOpen,
  onClose,
  youtubeUrl,
  title,
}: YoutubeModalProps) => {
  return (
    <Modal
      Icon={
        <Box
          p={Spacing.s3}
          style={theme => ({
            border: `1px solid ${theme.colors.gray[2]}`,
            borderRadius: theme.radius.md,
            boxShadow: theme.shadows.xs,
          })}
        >
          <IconPlayCircle size={24} color="gray.7" />
        </Box>
      }
      opened={isOpen}
      title={title}
      size={'xl'}
      onClose={onClose}
    >
      <Flex justify="center" align="center">
        <iframe
          width="560"
          height="315"
          src={`${youtubeUrl}?rel=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Flex>
    </Modal>
  );
};
